/*
 * Created on 20.05.19
 *
 * Copyright(c) 1995 - 2019 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 *
 */

import { HttpEvent, HttpHeaderResponse } from '@angular/common/http';
import { LanguageService } from '../i18n/language.service';
import { LoggingService } from '../utils/logging.service';
import { I18N } from './http-error.i18n';

/**
 * Fehlermeldungen, die im Frontend angezeigt werden können.
 * Welche Fehler angezeigt werden entscheidet der
 * {@link HttpErrorInterceptor}.
 */
export class HttpError {

    /**
     * Länge der ID.
     */
    private static readonly ID_LENGTH: number = 16;

    /**
     * Fehlermeldung für aktuell gewählte Sprache.
     */
    public readonly message: string;

    /**
     * Eine ID mit der man eindeutig einen Fehler bestimmen kann.
     * Das ist notwendig, da sowohl Index als auch
     */
    public readonly id: string;

    private constructor(message: string) {
        this.id = HttpError.generateUniqueId();
        this.message = message;
    }

    /**
     * Erstellt aus einem Statuscode einen HttpError, der im Portal angezeigt werden kann.
     * Dafür wird die I18N-Übersetzung genutzt.
     *
     * @param statusCode
     * @param languageService
     * @param loggingService
     */
    public static fromI18N(statusCode: number, languageService: LanguageService, loggingService: LoggingService): HttpError {
        const i18n = I18N[languageService.getLanguage()];
        if (!i18n[statusCode]) {
            loggingService.debug(
                `Es gibt keine i18n-Übersetzung für den Status-Code "${statusCode}". ` +
                `Standardwert wird genutzt.`
            );
        }
        const message = i18n[statusCode] ? i18n[statusCode] : i18n['default'];
        return new HttpError(message);
    }

    /**
     * Erzeugt direkt ein HttpError-Objekt. Nur hilfreich um manuell Debugmeldungen zum Testen der Komponente
     * zu generieren.
     *
     * @param message
     */
    public static fromMessage(message: string): HttpError {
        return new HttpError(message);
    }

    private static generateUniqueId(): string {
        let result = 'error-id#';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < this.ID_LENGTH; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
    }
}
